import { apiRequest } from '../../../../shared/http/transport.js';

export function fetchProfile({ signal } = {}) {
  return apiRequest({ path: '/api/profile', signal });
}

export function saveProfile({ profile, version }) {
  return apiRequest({ path: '/api/profile', method: 'PUT', body: { ...profile, version } });
}
